module.exports = __webpack_public_path__ + "img/question-tooltip.4016dd6b.svg";